import { CatalogResourceType } from "@evergis/api";
import defMap from "./assets/map.svg";
import defPoints from "./assets/points.svg";
import defPoly from "./assets/poly.svg";
import defRaster from "./assets/raster.svg";
import defNoGeom from "./assets/table.svg";
import defLines from "./assets/lines.svg";
import defTablePoints from "./assets/pointsGrey.svg";
import defTablePoly from "./assets/polyGrey.svg";
import defTableRaster from "./assets/rasterGrey.svg";
import defTableNoGeom from "./assets/tableGrey.svg";
import defTableLines from "./assets/linesGrey.svg";
import wms from "./assets/wms.svg";
import arcgis from "./assets/arcgis.svg";
import xyz from "./assets/xyz.svg";
import fileIcon from "./assets/file.svg";
import fileCsvIcon from "./assets/file_csv.svg";
import fileDocxIcon from "./assets/file_docx.svg";
import fileJpegIcon from "./assets/file_jpeg.svg";
import fileJpgIcon from "./assets/file_jpg.svg";
import fileJsonIcon from "./assets/file_json.svg";
import fileKmlIcon from "./assets/file_kml.svg";
import filePdfIcon from "./assets/file_pdf.svg";
import filePngIcon from "./assets/file_png.svg";
import filePptxIcon from "./assets/file_pptx.svg";
import filePyIcon from "./assets/file_py.svg";
import fileShpIcon from "./assets/file_shp.svg";
import fileTxtIcon from "./assets/file_txt.svg";
import fileXlsxIcon from "./assets/file_xlsx.svg";
import fileZipIcon from "./assets/file_zip.svg";
import postgreSql from "./assets/postgre_sql.svg";
import schema from "./assets/schema.svg";
import amazonS3 from "./assets/amazon_s3_preview.svg";
import arcGISServer from "./assets/arcgis_server.svg";
import arcGISMapServer from "./assets/arcgis_map_server.svg";
import arcGISFeatureServer from "./assets/arcgis_feature_server.svg";
import { FileType } from "./types";

// eslint-disable-next-line max-lines-per-function
export const getFileTypeIcon = (fileType?: FileType, resourceType?: CatalogResourceType) => {
  switch (fileType) {
    case FileType.CSV:
      return fileCsvIcon;
    case FileType.XLSX:
      return fileXlsxIcon;
    case FileType.DOCX:
      return fileDocxIcon;
    case FileType.PDF:
      return filePdfIcon;
    case FileType.JSON:
      return fileJsonIcon;
    case FileType.KML:
      return fileKmlIcon;
    case FileType.PPTX:
      return filePptxIcon;
    case FileType.SHP:
      return fileShpIcon;
    case FileType.TXT:
      return fileTxtIcon;
    case FileType.ZIP:
      return fileZipIcon;
    case FileType.IMAGE:
      return fileJpegIcon;
    case FileType.JPG:
      return fileJpgIcon;
    case FileType.PNG:
      return filePngIcon;
    case FileType.PYTHON:
      return filePyIcon;
    case FileType.MAP:
      return defMap;
    case FileType.LINES:
      return resourceType === CatalogResourceType.Table ? defTableLines : defLines;
    case FileType.TABLE:
      return resourceType === CatalogResourceType.Table ? defTableNoGeom : defNoGeom;
    case FileType.POINTS:
      return resourceType === CatalogResourceType.Table ? defTablePoints : defPoints;
    case FileType.POLYGON:
      return resourceType === CatalogResourceType.Table ? defTablePoly : defPoly;
    case FileType.RASTER:
      return resourceType === CatalogResourceType.Table ? defTableRaster : defRaster;
    case FileType.WMS:
      return wms;
    case FileType.ARCGIS:
      return arcgis;
    case FileType.XYZ:
      return xyz;
    case FileType.PostreSQL:
      return postgreSql;
    case FileType.PostgresSchema:
      return schema;
    case FileType.AmazonS3:
      return amazonS3;
    case FileType.ArcGISServer:
      return arcGISServer;
    case FileType.ArcGISMapServer:
      return arcGISMapServer;
    case FileType.ArcGISFeatureServer:
      return arcGISFeatureServer;
    default:
      return fileIcon;
  }
};
